// extracted by mini-css-extract-plugin
export default {"container":"container__Y56nQ","skeleton":"skeleton__MM6Z4","content":"content__zE8wO"};